// One cell of the summary at the top of a detail (appointment, task): its icon, then its label over its value.
// `wrap`: a long value (an address) goes on to the next line instead of being cut.
const SummaryCell = ({ icon, iconClass = 'text-gray-500', label, value, valueClass = 'text-gray-900', className = '', wrap = false }) => (
  <div className={`flex min-w-0 items-center gap-3 p-3 ${className}`}>
    <span className={`flex size-8 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white ${iconClass}`}>{icon}</span>
    <div className="min-w-0">
      <p className="text-xs text-gray-500">{label}</p>
      <p className={`${wrap ? 'break-words' : 'truncate'} text-sm font-medium ${valueClass}`}>{value}</p>
    </div>
  </div>
);

export default SummaryCell;
